<template>
  <div class="flex gap-x-4 justify-center gap-y-2 w-full flex-wrap">
    <div
      v-for="caption in captions"
      :key="caption.label"
      class="flex items-center gap-2"
    >
      <div
        :class="{
          'w-[20px] h-[5px] rounded': caption.type === 'line',
          'w-[4px] h-[4px] rounded mx-auto my-0': caption.type === 'dot',
        }"
        :style="`background: ${caption.color}`"
      ></div>
      <div class="font-normal text-xs">{{ caption.label }}</div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { buyBoxDatePickerMarkerColors } from '~/composables/useEventBuyBoxDatePicker'

const { t } = useI18n()

export type BuyBoxDatePickerCaptionIds =
  | 'publicDate'
  | 'privateDate'
  | 'soldOut'
  | 'dateRequest'

const props = withDefaults(
  defineProps<{
    disable?: BuyBoxDatePickerCaptionIds[]
  }>(),
  {
    disable: () => [],
  }
)

const captions = computed(() => {
  const arr: {
    id: BuyBoxDatePickerCaptionIds
    label: string
    color: string
    type: 'dot' | 'line'
  }[] = [
    {
      id: 'publicDate',
      label: t('product.show.datePickerCaptions.publicDateLabel'),
      color: buyBoxDatePickerMarkerColors.PUBLIC,
      type: 'line',
    },
    {
      id: 'privateDate',
      label: t('product.show.datePickerCaptions.privateDateLabel'),
      color: buyBoxDatePickerMarkerColors.PRIVATE,
      type: 'line',
    },
    {
      id: 'soldOut',
      label: t('product.show.datePickerCaptions.soldOutLabel'),
      color: buyBoxDatePickerMarkerColors.red,
      type: 'line',
    },
    {
      id: 'dateRequest',
      label: t('product.show.datePickerCaptions.dateRequestLabel'),
      color: '#CBD5E1',
      type: 'dot',
    },
  ]
  return arr.filter((x) => !props.disable.includes(x.id))
})
</script>
